module.exports = __webpack_public_path__ + "img/pf-719678a8--asseenonstheader_337x.76826426.png";